import { render } from "./date.vue?vue&type=template&id=1d18385c"
import script from "./date.vue?vue&type=script&lang=js"
export * from "./date.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d18385c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d18385c', __exports__)) {
    console.log('reload')
    api.reload('1d18385c', __exports__)
  }
  
  module.hot.accept("./date.vue?vue&type=template&id=1d18385c", () => {
    console.log('re-render')
    api.rerender('1d18385c', render)
  })

}


export default __exports__